/**
 * @file app-routing.module.ts
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule, TitleStrategy } from '@angular/router';

import { CustomTitleStrategy } from '@shared/utils';
import {
  CompleteProfileComponent,
  ForgotUsernameComponent,
  PreCompleteProfileComponent,
  PrivacyPolicyComponent,
  SsoErrorComponent,
  TermsOfUseComponent,
} from './features';
import { MSALGuardCustom } from '@core/guards';
import { LogoutComponent } from '@features/logout/logout.component';
import { PharmacySsoErrorComponent } from '@features/pharmacy-sso-error/pharmacy-sso-error.component';

export const routes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  {
    path: 'main',
    loadChildren: () =>
      import('./features/main/main.module').then((m) => m.MainModule),
    canActivate: [MSALGuardCustom],
  },
  {
    path: 'guest-login',
    loadChildren: () =>
      import('./features/guest-user/guest-user.module').then(
        (m) => m.GuestUserModule
      ),
  },
  {
    path: 'delete-member-account',
    loadChildren: () =>
      import('./features/delete-account/delete-member-account.module').then(
        (m) => m.DeleteMemberAccountModule
      ),
  },
  {
    path: 'sign-up',
    loadChildren: () =>
      import('./features/registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  { path: 'terms-of-use', component: TermsOfUseComponent, pathMatch: 'full' },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    pathMatch: 'full',
  },
  {
    path: 'pre-complete-profile',
    component: PreCompleteProfileComponent,
    pathMatch: 'full',
  },
  {
    path: 'complete-profile',
    component: CompleteProfileComponent,
    pathMatch: 'full',
  },
  {
    path: 'forgot-username',
    component: ForgotUsernameComponent,
    pathMatch: 'full',
    title: 'Forgot Username',
  },
  {
    path: 'logout',
    component: LogoutComponent,
    pathMatch: 'full',
    title: 'Logout',
  },
  { path: 'Error', component: SsoErrorComponent, pathMatch: 'full' },
  { path: 'pharmacy-sso-error', component: PharmacySsoErrorComponent, pathMatch: 'full' },
  { path: '**', redirectTo: 'main', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
  ],
})
export class AppRoutingModule {}
